// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const GcpGkeAutoscalingProfile = {
  GkeAutoscalingProfileOptimizeUtilization: 'OPTIMIZE_UTILIZATION',
  GkeAutoscalingProfileBalanced: 'BALANCED',
} as const;
export type GcpGkeAutoscalingProfile =
  (typeof GcpGkeAutoscalingProfile)[keyof typeof GcpGkeAutoscalingProfile];

export function instanceOfGcpGkeAutoscalingProfile(value: any): boolean {
  for (const key in GcpGkeAutoscalingProfile) {
    if (Object.prototype.hasOwnProperty.call(GcpGkeAutoscalingProfile, key)) {
      if (
        GcpGkeAutoscalingProfile[
          key as keyof typeof GcpGkeAutoscalingProfile
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function GcpGkeAutoscalingProfileFromJSON(
  json: any,
): GcpGkeAutoscalingProfile {
  return GcpGkeAutoscalingProfileFromJSONTyped(json, false);
}

export function GcpGkeAutoscalingProfileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GcpGkeAutoscalingProfile {
  return json as GcpGkeAutoscalingProfile;
}

export function GcpGkeAutoscalingProfileToJSON(
  value?: GcpGkeAutoscalingProfile | null,
): any {
  return value as any;
}

export function GcpGkeAutoscalingProfileToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): GcpGkeAutoscalingProfile {
  return value as GcpGkeAutoscalingProfile;
}
